import Navbar from "../../../components/Navbar/Navbar";
import PaymentCards from "../components/PaymentCards/PaymentCards";

export default function PaymentCardsPage() {
    return (
        <>
            <Navbar title="Payment Cards" />
            <div className="page">
                <PaymentCards />
            </div>
        </>
    );
}
